// Wrapper mỏng quanh os.platform() để các module khác switch theo OS dễ hơn
// và test dễ mock.
import { platform } from "node:os";

export type HostPlatform = "darwin" | "linux" | "win32" | "unsupported";

// Trả về tên platform chuẩn hoá. Mọi giá trị khác 3 OS chính → "unsupported".
export function detectHostPlatform(): HostPlatform {
  const p = platform();
  if (p === "darwin" || p === "linux" || p === "win32") return p;
  return "unsupported";
}
